import { render, staticRenderFns } from "./editAttendanceClasses.vue?vue&type=template&id=58a34ffe&scoped=true"
import script from "./editAttendanceClasses.vue?vue&type=script&lang=js"
export * from "./editAttendanceClasses.vue?vue&type=script&lang=js"
import style0 from "./editAttendanceClasses.vue?vue&type=style&index=0&id=58a34ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a34ffe",
  null
  
)

export default component.exports